<template>
  <div class="right_tools" :class="{active: mobTools}">
    <div class="over_tools">
      <div class="icon_mob_click">
        <div class="icon">
          <div @click="mobTools = !mobTools">
            <img src="/vue/images/settings_icon.png">
          </div>
        </div>
      </div>
      <div class="right_settings">
        <div class="tab_menu">
          <ul>
            <li>
              <span class="active" @click="changeTab('tools', $event)">
                <img src="/vue/images/tab_menu_icon_1.png">
                <img src="/vue/images/tab_menu_icon_1_hover.png">
              </span>
            </li>
            <li>
              <span @click="changeTab('color', $event)">
                <img src="/vue/images/tab_menu_icon_2.png">
                <img src="/vue/images/tab_menu_icon_2_hover.png">
              </span>
            </li>
            <li>
              <span @click="changeTab('locale', $event)">
                <img src="/vue/images/tab_menu_icon_3.png">
                <img src="/vue/images/tab_menu_icon_3_hover.png">
              </span>
            </li>
          </ul>
        </div>
        <div class="show_tools" v-show="tabs.tools">
          <basic-info></basic-info>
          <contacts></contacts>
          <job-stack></job-stack>
          <profession></profession>
          <skills></skills>
          <languages></languages>
          <hobby></hobby>
          <education></education>
          <experience></experience>
          <social></social>
          <citizen></citizen>
        </div>
        <div class="show_tools" v-show="tabs.color">
          <tab-themes></tab-themes>
        </div>
        <div class="show_tools" v-show="tabs.locale">
          <set-locale></set-locale>
        </div>
      </div>
    </div>
    <photo-editor
        v-if="$store.getters.uploadPhotoCv"
        :image="$store.state.cv.photo || '/vue/images/user_img.jpg'"
        :dataUrl="'/api/user/image/change'"
    ></photo-editor>
  </div>
</template>
<script>
  import toolsFunctions from "../tools-functions.js";
  import BasicInfo from "../tools-components/BasicInfo";
  import Contacts from "../tools-components/Contacts";
  import Social from "../tools-components/Social";
  import JobStack from "../tools-components/JobStack";
  import Skills from "../tools-components/Skills";
  import Experience from "../tools-components/Experience";
  import Languages from "../tools-components/Languages";
  import Education from "../tools-components/Education";
  import Profession from "../tools-components/Profession";
  import Citizen from "../tools-components/Citizen";
  import Hobby from "../tools-components/Hobby";
  import photoEditor from "../tools-components/photo-editor";

  import SetLocale from "../language-tab-components/setLocale";

  import tabThemes from "../color-tab-components/themes";

  export default {
    components: {
      /* language-tab */
      SetLocale,
      /* end */
      /* color-tab */
      tabThemes,
      /* end */
      /* tools-tab */
      BasicInfo,
      Contacts,
      Social,
      JobStack,
      Skills,
      Experience,
      Languages,
      Education,
      Profession,
      Citizen,
      Hobby,
      photoEditor
      /* end */
    },
    data() {
      return {
        mobTools: false,
        tabs: {
          tools: true,
          color: false,
          locale: false
        },
        degrees: [],
        professions: [],
        skills: [],
        languages: [],
        jobStacks: [],
        socialIcons: [],
        citizens: [],
        themes: [],
        currencies: [],
      };
    },
    mixins: [toolsFunctions],
    mounted() {
      this.addEvents();
      setTimeout(() => {
        if (this.$route.name.match(/cv-edit/)) {
          localStorage.clear();
          this.$parent.getCv(this.$route.params.cv)
            .then(res => {
              this.getCvTools(res.professionIds, res.skillIds, res.citizensIds);
            });
        } else {
          this.getCvTools();
        }
      }, 1);
    },
    computed: {
      cv_locale() {
        return this.$store.getters.cv_locale;
      }
    },
    watch: {
      cv_locale(to, from) {
        this.$store.state.cv.jobStack.sallery = 0;
        this.getCvTools();
      }
    },
    methods: {
      changeTab(tab, event) {
        for (let item in this.tabs) {
          this.tabs[item] = item === tab;
        }
        document.querySelector(".tab_menu .active").classList.remove("active");
        event.target.classList.add("active");
      },
      getCvTools(professionIds = [], skillIds = [], citizensIds = []) {
        this.$http({
          method: "get",
          url: `/api/cv/tools?cv-locale=${this.$store.getters.cv_locale}&tariff=standard`,
          params: {
            professionIds,
            skillIds,
            citizensIds
          }
        }).then(res => {
          if (res.data) {
            this.degrees = res.data.degrees;
            this.professions = res.data.professions;
            this.skills = res.data.skills;
            this.languages = res.data.languages;
            this.jobStacks = res.data.jobStacks;
            this.socialIcons = res.data.socialIcons;
            this.citizens = res.data.citizens;
            this.themes = res.data.themes;
            this.currencies = res.data.currencies;
          }
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/tools/tools_standard.vue